import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getCustomerTasks, getTaskBaseInfo } from "@api/correspondence/task";
export default {
  name: 'strucType',
  props: {
    data: {
      default: function _default() {
        return [];
      }
    },
    selectId: {
      default: undefined
    },
    type: {
      default: 'children'
    },
    id: {
      default: undefined
    },
    name: {
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      singleTypeId: '',
      rightList: [],
      selectList: [],
      selectValues: [],
      currentTableData: [],
      multipleSelection: [],
      total: 0,
      currentPage: 1,
      pageSize: 99,
      loading: false,
      key: '',
      disabled: false
    };
  },
  computed: {
    titles: function titles() {
      if (this.type === 'children') {
        return ['待指定上级作业', '已指定上级作业'];
      } else if (this.type === 'parent') {
        return ['待指定作业', '上级作业信息'];
      }
      return ['待选', '已选'];
    },
    dataList: function dataList() {
      var _this = this;
      var data = this.currentTableData.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          _checked: false
        });
      });
      data = data.filter(function (item) {
        return item.c01Id !== _this.id;
      });
      if (this.selectList.length) {
        var ids = this.selectList.map(function (item) {
          return item.c01Id;
        });
        var res = data.filter(function (item) {
          return ids.indexOf(item.c01Id) === -1;
        });
        return res;
      }
      return data;
    },
    combineSearch: function combineSearch() {
      if (this.key) {
        if (this.type === 'children') {
          var str = this.key.split(',');
          var param = str.map(function (item) {
            return "c01CusName-%".concat(item, "%");
          });
          return "or/".concat(param.join('/'));
        } else {
          return "all/c01StrucType-\u5408\u5E76/c01CusName-%".concat(this.key, "%");
        }
      }
      if (this.type === 'children') {
        return "all/";
      }
      return '';
    }
  },
  methods: {
    del: function del(item) {
      this.selectList = this.selectList.filter(function (child) {
        return child.c01Id !== item.c01Id;
      });
    },
    getTaskName: function getTaskName(ids) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (ids.length) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _this2.$awaitTo(getTaskBaseInfo({
                TaskIdsJson: JSON.stringify(ids)
              }));
            case 2:
              _yield$_this2$$awaitT = _context.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              if (Array.isArray(data.data) && data.data.length) {
                _this2.selectList = data.data;
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    selectable: function selectable(row) {
      return row.c01Id !== this.id;
    },
    handleItemSelectionChange: function handleItemSelectionChange(val, item) {
      this.singleTypeId = item.c01Id;
      this.multipleSelection = [item];
      this.turnToSelectList();
    },
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getData('next');
    },
    select: function select() {
      var _this3 = this;
      var list = this.currentTableData.filter(function (item) {
        return _this3.data.indexOf(item.c01Id) !== -1;
      });
      list.forEach(function (row) {
        _this3.$refs.multipleTable.toggleRowSelection(row);
      });
    },
    submit: function submit() {
      this.$emit('submit', this.selectList);
    },
    turnToSelectList: function turnToSelectList() {
      var _this$selectList;
      if (this.type !== 'children' && this.selectList.length) {
        this.$message.warning('你已有指定作业,请先删除已指定作业,再变更');
        this.singleTypeId = '';
        return;
      }
      (_this$selectList = this.selectList).push.apply(_this$selectList, _toConsumableArray(this.multipleSelection));
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.turnToSelectList();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var d, params, _yield$getCustomerTas, data, _d, datas;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this4.multipleSelection = [];
              if (!(!_this4.key && type !== 'next')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _this4.loading = true;
              if (!(_this4.type === 'parent' || _this4.type === 'children')) {
                _context2.n = 3;
                break;
              }
              params = {
                combineSearch: _this4.combineSearch,
                page: _this4.currentPage,
                length: 20
              };
              _context2.n = 2;
              return getCustomerTasks({
                TableConfig: JSON.stringify(params),
                key: ''
              });
            case 2:
              _yield$getCustomerTas = _context2.v;
              data = _yield$getCustomerTas.data;
              d = data;
            case 3:
              _this4.loading = false;
              _d = d, datas = _d.datas;
              _this4.total = d.total;
              _this4.currentTableData = datas;
              // this.getTaskName(this.selectValues)
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    if (this.type === 'children') {
      if (this.data) {
        this.selectValues = this.data;
        this.getTaskName(this.selectValues);
      }
    } else {
      if (this.selectId) {
        this.selectValues = [this.selectId];
        this.getTaskName(this.selectValues);
      }
    }
  },
  mounted: function mounted() {}
};